/*
  Opens the WhatsApp enquiry chooser, and times the greeting on the floating
  button.

  The problem it solves: a bare wa.me link opens an empty chat, so every
  enquiry starts with the shopper typing what they want and us asking which
  order they mean. The options each carry their own prefilled message, so the
  first line of the conversation is already useful.

  The choosing is done in the markup, not here — snippets/pujalane-whatsapp.liquid
  renders the wa.me links with their text baked in, and decides which questions
  belong on the page. This file only opens and closes the panel holding them,
  which is why a shopper on a flaky connection where this script never arrives
  still gets a working button: the toggle is itself an anchor to a general
  chat, and without the upgrade below a tap simply follows it.

  Loaded globally from theme.liquid, because the header icon is on every page.
  Both the header icon and the product page's floating button can be in the DOM
  at once, so every instance is wired separately.

  Styles: pujalane-card-style.css sections 23, 26 and 27.
*/
(function () {
  // Measured from page load. The greeting is a nudge for someone who has been
  // reading a while without deciding, so it deliberately misses the arrival —
  // popping up immediately would be one more thing to dismiss on a page that
  // already has a sticky bar.
  var HELLO_IN = 15000;
  var HELLO_OUT = 20000;

  function init(root) {
    var toggle = root.querySelector('[data-pl-wa-toggle]');
    var menu = root.querySelector('[data-pl-wa-menu]');
    if (!toggle || !menu) return;

    // Upgrade the anchor in place. Done in script rather than in the markup so
    // the no-JS fallback stays a plain link that behaves like one — announcing
    // "button, collapsed" for something that would navigate on tap would be a
    // lie to a screen reader if this file failed to load.
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-haspopup', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (menu.id) toggle.setAttribute('aria-controls', menu.id);

    var open = false;

    function setOpen(next) {
      open = next;
      menu.hidden = !next;
      toggle.setAttribute('aria-expanded', String(next));

      if (next) {
        root.setAttribute('data-open', '');
        // The greeting has been answered by the panel it was inviting.
        root.removeAttribute('data-hello');
      } else {
        root.removeAttribute('data-open');
      }
    }

    toggle.addEventListener('click', function (event) {
      // Take the navigation over only now that the panel is definitely here.
      event.preventDefault();

      // Read this before the panel opens: once focus has moved the answer
      // changes. :focus-visible is the browser's own "did they get here by
      // keyboard" verdict — moving focus into the panel on a thumb tap would
      // paint a focus ring nobody asked for.
      var viaKeyboard = false;
      try {
        viaKeyboard = toggle.matches(':focus-visible');
      } catch (e) {
        // Safari below 15.4 throws on the unsupported selector rather than
        // returning false. Not moving focus is the safe answer there.
      }

      setOpen(!open);
      if (open && viaKeyboard) {
        var first = menu.querySelector('.pl-wa-menu__opt');
        if (first) first.focus();
      }
    });

    // Tapping the page behind the panel dismisses it, the way a sheet should.
    // Anything inside this instance is either the toggle or an option, both of
    // which handle themselves.
    document.addEventListener('click', function (event) {
      if (!open || root.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (!open || event.key !== 'Escape') return;
      setOpen(false);
      toggle.focus();
    });

    // Chosen an option: the tab that opens is WhatsApp's, and coming back to a
    // panel still hanging open over the product would be clutter.
    menu.addEventListener('click', function (event) {
      if (event.target.closest('.pl-wa-menu__opt')) setOpen(false);
    });

    // ---------- the timed greeting (floating button only) ----------

    if (!root.querySelector('[data-pl-wa-hello]')) return;

    setTimeout(function () {
      // Nothing to invite them to if the panel is already open.
      if (!open) root.setAttribute('data-hello', '');
    }, HELLO_IN);

    setTimeout(function () {
      root.removeAttribute('data-hello');
    }, HELLO_OUT);
  }

  var roots = document.querySelectorAll('[data-pl-wa]');
  Array.prototype.forEach.call(roots, init);
})();
